import { toZonedTime } from 'date-fns-tz';

export const getDateByUserTimezone = (userTimezone: string) => {
  const zonedDate = toZonedTime(new Date().toISOString(), userTimezone);
  const offset = zonedDate.getTimezoneOffset();
  const queryDate = new Date(zonedDate.getTime() - offset * 60000);
  return { queryDate, zonedDate };
};

export const convertDateByUserTimezone = (dateUTC: string, userTimezone: string) => {
  const zonedDate = toZonedTime(dateUTC, userTimezone);
  return zonedDate;
};
